import { render, staticRenderFns } from "./DbpyPL_List.vue?vue&type=template&id=22812df4"
import script from "./DbpyPL_List.vue?vue&type=script&lang=js"
export * from "./DbpyPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports